<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Users</a>
        </li>
        <li class="breadcrumb-item">
          <a>API Keys</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Expiry Date</th>
              <th scope="col">Key</th>
              <th scope="col"><button class="btn btn-success" (click)="addNewKey()">Add</button></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of keys" [class.text-danger]="isExpired(key)">
              <td>{{key.name}}</td>
              <td>
                {{key.expiryDate | date}}
                <span *ngIf="isExpired(key)" class="badge rounded-pill text-bg-danger ml-1">EXPIRED</span>
                <span *ngIf="!isExpired(key)" class="badge rounded-pill text-bg-success ml-1">ACTIVE</span>
              </td>
              <td *ngIf="key.key == null">
                <button (click)="revealKey(key)" class="btn btn-sm btn-outline-secondary">Reveal</button>
              </td>
              <td *ngIf="key.key">{{key.key}}</td>
              <td><button (click)="revokeKey(key)" class="btn btn-danger">Revoke</button></td>
            </tr>
            <tr *ngIf="newKey">
              <td><input type="text" class="form-control" [(ngModel)]="newKey.name" [ngClass]="{'is-invalid':newKey.name == null || newKey.name == ''}"></td>
              <td><input type="datetime-local" class="form-control" [(ngModel)]="newKey.expiryDate" [ngClass]="{'is-invalid':newKey.expiryDate == null || newKey.expiryDate == ''}" [min]="minDate" [max]="maxDate"></td>
              <td></td>
              <td><button (click)="saveNewKey()" class="btn btn-success" [disabled]="newKey.name == null || newKey.name == '' || newKey.expiryDate == null || newKey.expiryDate == ''">Add</button></td>
            </tr>
            <tr *ngIf="keys == null || keys.length == 0">
              <td colspan="4">No API Keys</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>  

  